import { Component, Input, inject, output } from '@angular/core';
import { Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PlanType, ShieldPlanType } from '@bn/app-shield';
import { UserStateService } from '@bn/auth/stores';
import { DashboardSharedModule } from '@bn/dashboard-shared';
import { SupportDepartmentType } from '@bn/shared/entities/enums';
import { PullZoneStore, StoreRequest } from '@bn/shared/state-store';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { CardComponent } from '@bn/web-ui/card/card.component';
import { ShieldApiStore } from '../../stores';

@Component({
  selector: 'app-shield-pricing-table',
  templateUrl: './app-shield-pricing-table.component.html',
  styleUrls: ['./app-shield-pricing-table.component.scss'],
  imports: [BadgeComponent, ButtonComponent, CardComponent, DashboardSharedModule, FaIconComponent],
})
export class AppShieldPricingTableComponent {
  private readonly router = inject(Router);

  readonly #shieldStore = inject(ShieldApiStore);
  readonly #pullZoneStore = inject(PullZoneStore);

  protected readonly planType = PlanType;

  public getSelectedPullZone = this.#pullZoneStore.selectedEntity();
  public getSelectedShieldId = this.#shieldStore.selectedEntityId();
  public isUpdating = this.#shieldStore.isLoading(StoreRequest.Update);
  public selectedShieldPackage = PlanType.Advanced;
  public userStore = inject(UserStateService).userStore;

  @Input()
  public isSetup = false;

  @Input()
  public set shieldPackage(currentPackage: ShieldPlanType | undefined) {
    if (currentPackage !== null && currentPackage !== undefined) {
      this.selectedShieldPackage = currentPackage;
    }
  }

  @Input()
  public noShadow?: boolean;

  @Input()
  public noBorder?: boolean;

  public readonly selectShieldPackage = output<number>();

  public onChoosePackage(shieldPackage: ShieldPlanType) {
    if (this.isSetup) {
      this.selectedShieldPackage = shieldPackage;
    }

    this.selectShieldPackage.emit(shieldPackage);
  }

  public onContactSupportClick(): void {
    let Message = `Pull Zone ID: ${this.getSelectedPullZone()?.Id}`;
    const currentShieldId = this.getSelectedShieldId();

    if (currentShieldId) {
      Message += `\nBunny Shield ID: ${currentShieldId}`;
    }

    this.router.navigate([`support/tickets/new`], {
      queryParams: {
        Department: SupportDepartmentType.Sales,
        Issue: 7,
        Subject: `I’m interested in Bunny Shield Enterprise`,
        Message,
      },
    });
  }
}
